import { render, staticRenderFns } from "./vehicle-tips.vue?vue&type=template&id=676b6002&scoped=true&"
import script from "./vehicle-tips.vue?vue&type=script&lang=js&"
export * from "./vehicle-tips.vue?vue&type=script&lang=js&"
import style0 from "./vehicle-tips.vue?vue&type=style&index=0&id=676b6002&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676b6002",
  null
  
)

export default component.exports